var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModal",
        {
          attrs: { titulo: "Editar Técnico" },
          on: { cerrar: _vm.handleCerrar }
        },
        [
          _c("div", {
            staticStyle: {
              "letter-spacing": "0.02em",
              "white-space": "nowrap",
              overflow: "hidden",
              "text-overflow": "ellipsis",
              "margin-top": "16px"
            }
          }),
          _c(
            "div",
            { staticClass: "boton_crear" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "icon",
                  staticStyle: {
                    "background-color": "rgb(255, 108, 0)",
                    "border-color": "rgb(255, 108, 0)",
                    "padding-right": "20px",
                    display: "block",
                    margin: "0 0 0 auto",
                    "margin-top": "13px",
                    height: "38px"
                  },
                  on: { click: _vm.editar2 }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "color-blanco",
                      staticStyle: { color: "white" }
                    },
                    [_vm._v("Guardar")]
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos, "validar-paso": false },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c("ContenidoModal", [
        _c(
          "div",
          { attrs: { align: "center" } },
          [
            _c(
              "v-flex",
              { attrs: { md10: "" } },
              [
                _c(
                  "v-card",
                  { staticClass: "rounded-card" },
                  [
                    _c(
                      "v-form",
                      {
                        ref: "form",
                        staticClass: "col-md-12",
                        attrs: { "lazy-validation": "" }
                      },
                      [
                        _c(
                          "v-container",
                          {
                            staticStyle: { padding: "30px 40px 50px 40px" },
                            attrs: { "grid-list-md": "" }
                          },
                          [
                            _c(
                              "FormFieldsContainer",
                              { attrs: { titulo: "Editar Técnico" } },
                              [
                                _vm._t("prependInformacionGeneral"),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: _vm.formFields.id.label,
                                        disabled: ""
                                      },
                                      model: {
                                        value: _vm.formFields.id.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.id,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.id.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required|max:80|alpha_spaces",
                                          expression:
                                            "'required|max:80|alpha_spaces'"
                                        }
                                      ],
                                      attrs: {
                                        label: _vm.formFields.nombre.label,
                                        "error-messages": _vm.errors.collect(
                                          "name"
                                        ),
                                        "data-vv-name": "name",
                                        counter: 80,
                                        type: "text",
                                        required: "",
                                        disabled: _vm.bloquear
                                      },
                                      model: {
                                        value: _vm.formFields.nombre.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.nombre,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.nombre.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required|max:80|alpha_spaces",
                                          expression:
                                            "'required|max:80|alpha_spaces'"
                                        }
                                      ],
                                      attrs: {
                                        label: _vm.formFields.apellido.label,
                                        "error-messages": _vm.errors.collect(
                                          "lastname"
                                        ),
                                        "data-vv-name": "lastname",
                                        counter: 80,
                                        type: "text",
                                        disabled: _vm.bloquear,
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.formFields.apellido.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.apellido,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.apellido.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: _vm.formFields.rut.label,
                                        rules: [_vm.rules.rut],
                                        disabled: _vm.bloquear,
                                        type: "text",
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.formFields.rut.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.rut,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.rut.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "max:60",
                                          expression: "'max:60'"
                                        }
                                      ],
                                      attrs: {
                                        "error-messages": _vm.errors.collect(
                                          "direccion"
                                        ),
                                        "data-vv-name": "direccion",
                                        label: "Dirección",
                                        counter: 60,
                                        type: "text",
                                        disabled: _vm.bloquear
                                      },
                                      model: {
                                        value: _vm.formFields.direccion.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.direccion,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.direccion.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: {
                                            rules: {
                                              required: true,
                                              max: 200,
                                              email: true,

                                              regex: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/
                                            }
                                          },
                                          expression:
                                            "{\n                      rules: {\n                        required: true,\n                        max: 200,\n                        email: true,\n\n                        regex: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.([a-zA-Z]{2,4})+$/,\n                      },\n                    }"
                                        }
                                      ],
                                      attrs: {
                                        label: _vm.formFields.email.label,
                                        "error-messages": _vm.errors.collect(
                                          "email"
                                        ),
                                        "data-vv-name": "email",
                                        counter: 200,
                                        required: "",
                                        disabled: _vm.bloquear
                                      },
                                      model: {
                                        value: _vm.formFields.email.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.email,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.email.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: {
                                            max: 11
                                          },
                                          expression:
                                            "{\n                      max: 11,\n                    }"
                                        }
                                      ],
                                      attrs: {
                                        label: _vm.formFields.tel.label,
                                        "error-messages": _vm.errors.collect(
                                          "telefonoFijo"
                                        ),
                                        "data-vv-name": "telefonoFijo",
                                        placeholder: "56299999999",
                                        counter: 11,
                                        type: "tel",
                                        disabled: _vm.bloquear
                                      },
                                      model: {
                                        value: _vm.formFields.tel.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.tel,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.tel.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-combobox", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      attrs: {
                                        label: _vm.formFields.localidad.label,
                                        items: _vm.localidadeslist,
                                        "item-text": "locaname",
                                        "item-value": "locaid",
                                        disabled: _vm.bloquear,
                                        "error-messages": _vm.errors.collect(
                                          "localidad"
                                        ),
                                        "data-vv-name": "localidad",
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.formFields.localidad.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.localidad,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.localidad.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required|max:80",
                                          expression: "'required|max:80'"
                                        }
                                      ],
                                      attrs: {
                                        label: _vm.formFields.ubicacion.label,
                                        "error-messages": _vm.errors.collect(
                                          "ubicacion"
                                        ),
                                        "data-vv-name": "ubicacion",
                                        counter: 80,
                                        type: "text",
                                        required: "",
                                        disabled: _vm.bloquear
                                      },
                                      model: {
                                        value: _vm.formFields.ubicacion.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.ubicacion,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.ubicacion.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-autocomplete", {
                                      attrs: {
                                        label: _vm.formFields.estado.label,
                                        items: _vm.estados
                                      },
                                      model: {
                                        value: _vm.formFields.estado.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.estado,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.estado.value"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }